import './styles/main.scss';
import './scripts/main';
// import './scripts/misc/stepper';
import './scripts/misc/number-stepper';
import './scripts/pages/custom-checkout';
import './scripts/pages/wc-checkout';

console.log('index.ts loaded 2');